'use client';
import { CloseBigIcon } from '@/components/icons/svg-icons';
import { Button } from '@nf/ui';
import { useEffect } from 'react';
import { useStreamingStore } from '@/store/streaming';

export const IframeBase = () => {
	const [
		streamingUrl,
		streamingSrc,
		streamingType,
		setIsRefresh,
		isStreamingFloat,
		setIsStreamingFloat,
		setStreamingType,
		setVideoSpecial,
		isEsport
	] = useStreamingStore(
		state => [
			state.streamingUrl,
			state.streamingSrc,
			state.streamingType,
			state.setIsRefresh,
			state.isStreamingFloat,
			state.setIsStreamingFloat,
			state.setStreamingType,
			state.setVideoSpecial,
			state.isEsport,
		]
	);
	useEffect(() => {
		setVideoSpecial((streamingSrc === '11' && streamingType !== 'StaticInfo') || isEsport ? false : true)
	}, [streamingSrc, streamingType]);
	useEffect(() => {
		const mediaQueryDesktop = window.matchMedia('(min-width: 769px)');
		const mediaQueryMobile = window.matchMedia('(min-width: 577px)');
		const handleMediaChange = () => {
			setIsRefresh(true);
			setTimeout(() => {
				setIsRefresh(false);
			}, 200);
		};
		mediaQueryDesktop.addEventListener('change', handleMediaChange);
		mediaQueryMobile.addEventListener('change', handleMediaChange);
		return () => {
			//reset video special to false when unmount
			setVideoSpecial(false);
			mediaQueryDesktop.removeEventListener('change', handleMediaChange);
			mediaQueryMobile.removeEventListener('change', handleMediaChange);
		};
	}, []);

	const handleIframeClose = () => {
		setIsStreamingFloat(false);
		setStreamingType('');
	};

	return (
		<div className="video-view video-view-ref">
			{isStreamingFloat ?
				<Button className="btn--icon btn--close" onClick={handleIframeClose}>
					<CloseBigIcon />
				</Button>
				: null}
			<iframe
				id="iframePlayer"
				src={streamingUrl}
				allow="fullscreen"
			>
			</iframe>
		</div>
	);
};
